import { Component } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';

@Component({
  selector: 'app-ilassist-privacy-policy',
  standalone: false,
  templateUrl: './ilassist-privacy-policy.component.html',
  styleUrl: './ilassist-privacy-policy.component.scss'
})
export class IlassistPrivacyPolicyComponent {
  SupportEmail = SUPPORT_EMAIL

}
